import type { AnyRoute } from "@tanstack/react-router";

import { createSupervisorAssignmentsRoutes as createRoutes } from "./createSupervisorAssignmentsRoutes";
import type { SupervisorAssignmentsRouteDeps } from "./supervisorAssignmentsRouteContext";

export type {
  SupervisorAssignmentsRouteDeps,
  SupervisorAssignmentsRouteFactory,
} from "./supervisorAssignmentsRouteContext";

export function createSupervisorAssignmentsRoutes(
  deps: SupervisorAssignmentsRouteDeps,
): AnyRoute[] {
  return [...createRoutes(deps)];
}
